import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ResultadoPcPage } from './resultado-pc';
import { ComponentsModule } from '../../../components/components.module'
import { DirectivesModule } from '../../../directives/directives.module';
import { PipesModule } from '../../../pipes/pipes.module';
// Translation
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

@NgModule({
  declarations: [
    ResultadoPcPage
  ],
  imports: [
    IonicPageModule.forChild(ResultadoPcPage),
    ComponentsModule,
    DirectivesModule,
    PipesModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
          deps: [ HttpClient ]
        }
    }),
  ],
})
export class ResultadoPcPageModule {}



// WEBPACK FOOTER //
// ./src/pages/personal-challenge/resultado-pc/resultado-pc.module.ts